"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = openDrawerTab;

function openDrawerTab(drawerRef, tabIndex) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      stayClosed = _ref.stayClosed;

  return function () {
    if (!drawerRef) {
      return;
    }

    if (drawerRef.state.selectedTab !== tabIndex) {
      drawerRef.setTabIndex(tabIndex);
    }

    if (!drawerRef.state.minimised || stayClosed) {
      return;
    }

    drawerRef.toggleMinimiseState();
  };
}